import Axios from "@/plugins/Axios";
// import store from "@/store";
import Acompanhamento from "@/Models/Acompanhamento";

export class AcompanhamentosService {
  async syncAllProfessoresFranquia(pageNumber, query) {
    const response = await Axios().get(
      `acompanhamentos-analise-consolidado?page=${pageNumber}&query=${query}`
    );

    return response.data;
  }

  async createOrUpdateBimestral(data) {
    const response = await Axios().post("/acompanhamentos-bimestrais", data);
    return response.data;
  }

  async createOrUpdateAnaliseEConsolidado(data) {
    const response = await Axios().post("/acompanhamentos-analise-consolidado", data);
    return response.data;
  }

  async pegarDadosBimestral(gestaoDeAulaId, disciplinaId) {
    const response = await Axios().get(
      `/acompanhamentos-bimestrais/${gestaoDeAulaId}/${disciplinaId}`
    );
    return response.data;
  }

  async pegarDadosAnaliseEConsolidado(professorId, configuracaoId) {
    const response = await Axios().get(
      `/acompanhamentos-analise-consolidado/${professorId}/${configuracaoId}`
    );
    return response.data;
  }

  async relatorioAcompanhamentoBimestral(configuracaoId) {
    const response = await Axios()
      .get(`/acompanhamentos-bimestrais/relatorio-acompanhamentos-bimestrais/${configuracaoId}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `acompanhamento_bimestral_do_plano_de_aula${configuracaoId}.pdf`;
        link.click();
      });
    return response;
  }

  async relatorioAcompanhamentoAnaliseEConsolidado(configuracaoId) {
    const response = await Axios()
      .get(`/acompanhamentos-analise-consolidado/relatorio-analise-consolidado/${configuracaoId}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `acompanhamento_bimestral_do_plano_de_aula${configuracaoId}.pdf`;
        link.click();
      });
    return response;
  }
}

export default new AcompanhamentosService();
